
import { defineComponent, toRef, ref, watch } from "vue";
import KTDatatable from "@/components/kt-datatable/KTDatatable.vue";
export default defineComponent({
  name: "perakuan-modal",
  components: {
    KTDatatable,
  },
  props: {
    calonData: { type: Array, required: true },
  },
  calonList() {
    return {
      checkbox: false,
    };
  },
  methods: {
    clearForm() {
      this.search = "";
    },
  },
  setup(props) {
    const calon = toRef(props, "calonData");
    const calonList = ref([] as any[]);
    // const calon = ref([])
    watch(calon, () => {
      calonList.value = calon.value;
    });
    const headerConfig = ref([
      {
        name: "Calon",
        key: "nama_penuh",
        sortable: false,
      },
      {
        name: "Hubungi",
        key: "emel",
        sortable: false,
      },
    ]);
    const search = ref("");

    watch(search, () => {
      calonList.value = calon.value;
      if (search.value !== "") {
        let results = [] as any[];
        for (let j = 0; j < calonList.value.length; j++) {
          console.log("data.value", calonList.value[j]);
          if (searchingFunc(calonList.value[j], search.value.toUpperCase())) {
            results.push(calonList.value[j]);
          }
        }
        calonList.value = results;
      } else {
        calonList.value = calon.value;
      }
    });
    const searchingFunc = (obj, value): boolean => {
      for (let key in obj) {
        if (!Number.isInteger(obj[key]) && !(typeof obj[key] === "object")) {
          if (obj[key].toUpperCase().indexOf(value) != -1) {
            return true;
          }
        }
      }
      return false;
    };
    return {
      calon,
      calonList,
      headerConfig,
      search,
    };
  },
});
